<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu></ucMenu>
					<div class="right_con">
						<div class="goods_main wx_order_page">
							<p class="fb">微店订单</p>

							<div class="select_wrap">
								<el-select
									class="w290"
									v-model="searchData.group_ids"
									placeholder="全部分组"
									clearable
									multiple
									collapse-tags
									filterable
									@change="onGroupChange"
								>
									<p slot="prefix" class="label_title">店铺分组</p>
									<el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable filterable>
									<p slot="prefix" class="label_title">店铺名</p>
									<el-option v-for="item in arrShop" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.product_keyword" placeholder="商品标题/商品ID" clearable>
									<p slot="prefix" class="label_title">商品信息</p>
								</el-input>
								<el-input class="w290" v-model="searchData.wx_order_id" placeholder="请输入微店订单号" clearable>
									<p slot="prefix" class="label_title">微店订单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.alibaba_order_id" placeholder="请输入采购订单号" clearable>
									<p slot="prefix" class="label_title">采购订单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.abb_purchase_remark" placeholder="请输入采购备注" clearable>
									<p slot="prefix" class="label_title">采购备注</p>
								</el-input>
								<el-input class="w290" v-model="searchData.purchase_account" placeholder="请输入采购账号" clearable>
									<p slot="prefix" class="label_title">采购账号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.express_no" placeholder="请输入采购快递单号" clearable>
									<p slot="prefix" class="label_title">采购快递单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData._static_return" placeholder="请输入买家退货单号" disabled>
									<p slot="prefix" class="label_title">买家退货单号</p>
								</el-input>
								<div class="w290 search-amount-range">
									<p class="label_title">实收金额</p>
									<div class="amount-inputs">
										<el-input v-model="searchData.order_price_min" placeholder="最小(元)" clearable class="amount-input"></el-input>
										<span class="amount-sep">-</span>
										<el-input v-model="searchData.order_price_max" placeholder="最大(元)" clearable class="amount-input"></el-input>
									</div>
								</div>
								<el-select class="w290" v-model="searchData.provinces" multiple collapse-tags placeholder="请选择" clearable filterable>
									<p slot="prefix" class="label_title">省份</p>
									<el-option v-for="item in arrProvince" :key="item" :label="item" :value="item"></el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.merchant_notes" placeholder="请输入商家备注" clearable>
									<p slot="prefix" class="label_title">商家备注</p>
								</el-input>
								<el-select class="w290" v-model="searchData.merchant_notes_tag_colors" multiple collapse-tags placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">旗帜颜色</p>
									<el-option v-for="item in arrTagColor" :key="item.val" :label="item.text" :value="item.val">
										<span style="float: left">{{ item.text }}</span>
										<span style="float: right;"><i class="el-icon-s-flag" :style="{ color: item.color }"></i></span>
									</el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.customer_notes" placeholder="请输入买家留言" clearable>
									<p slot="prefix" class="label_title">买家留言</p>
								</el-input>
								<el-select class="w290" v-model="searchData.problem_types" multiple collapse-tags placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">问题订单</p>
									<el-option v-for="item in arrProblemType" :key="item.val" :label="item.text" :value="item.val"></el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.relative_status" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">关联状态</p>
									<el-option label="未关联" value="unlinked"></el-option>
									<el-option label="已关联" value="linked"></el-option>
								</el-select>
								<el-date-picker
									v-model="createTimeRange"
									type="datetimerange"
									range-separator="至"
									start-placeholder="下单开始"
									end-placeholder="下单结束"
									value-format="timestamp"
									:default-time="['00:00:00', '23:59:59']"
								></el-date-picker>
								<div class="select_btns">
									<el-button type="danger" size="small" @click="onSearch">查询</el-button>
									<el-button size="small" plain @click="onReset">重置</el-button>
								</div>
							</div>

							<div class="tabs_wrap">
								<p
									v-for="tab in arrPurchaseStatus"
									:key="'pt-' + (tab.val === '' ? 'all' : tab.val)"
									class="tab"
									:class="{ active: String(searchData.purchase_biz_status) === String(tab.val) }"
									@click="onTab(tab.val)"
								>
									<el-badge
										:value="tab.num || purchaseCounts[tab.count_key] || 0"
										:hidden="isPurchaseTabCountHidden(tab)"
										class="tab_badge"
									>
										{{ tab.text }}
									</el-badge>
								</p>
							</div>

							<div class="totals_btn">
								<span class="total_text">共 {{ total }} 条</span>
								<div class="btn_group">
									<el-button size="small" plain @click="batchSoftDelete">批量删除</el-button>
									<el-button size="small" plain @click="batchPurchase">批量厂家直采</el-button>
									<el-button size="small" plain @click="orderExport">批量导出</el-button>
									<el-button
										size="small"
										plain
										@click="openBatchAlibabaConnect"
									>批量关联</el-button>
									<el-button size="small" plain @click="bindBatchMarkProblem">标记问题</el-button>
									<el-button size="small" plain @click="bindBatchMarkException">批量标记异常</el-button>
									<el-button size="small" plain @click="openAddressImport">导入买家信息</el-button>
									<el-button
										size="small"
										plain
										:loading="syncRunningCount > 0"
										@click="openSyncWxOrder()"
									>{{ syncRunningCount > 0 ? '正在同步' : '同步微店订单' }}</el-button>
								</div>
							</div>

							<div class="list_title">
								<p class="checkall">
									<el-checkbox
										v-model="checkAll"
										:indeterminate="checkIndeterminate"
										@change="onCheckAll"
									></el-checkbox>
								</p>
								<p class="t1">货品信息<i class="el-icon-view title_eye" @click="showOrderInfo"></i></p>
								<p class="t2">售价/数量</p>
								<p class="t3">订单状态</p>
								<p class="t4">金额</p>
								<p class="t5">退货信息</p>
								<p class="t6">
									采购单详情
									<el-tooltip effect="dark" content="按每个1688采购单展示商品、SKU、运单及状态；修改关联请在右侧操作列" placement="top">
										<i class="el-icon-info purchase_col_tip"></i>
									</el-tooltip>
								</p>
								<p class="t7">操作</p>
							</div>

							<ul class="order_list" v-loading="loading">
								<li v-for="item in list" :key="item.id">
									<div class="info_top">
										<el-checkbox
											class="row_check"
											:value="checkList.indexOf(item.id) > -1"
											@change="(val) => onCheckRow(item.id, val)"
										></el-checkbox>
										<span class="shop_name">{{ isHideOrderInfo ? '************' : item.shop_name }}</span>
										<span class="order_no">微店单号：{{ item.wx_order_id }}
											<a href="javascript:;" class="copy" @click="copyText(item.wx_order_id)">复制</a>
										</span>
										<span class="ctime">下单时间：{{ formatTime(item.create_time) }}</span>
										<el-button
											class="abnormal_btn"
											plain
											size="mini"
											:type="item.is_abnormal > 0 ? 'warning' : ''"
											@click="bindMarkProblem(item)"
										>标记问题</el-button>
										<el-button
											class="abnormal_btn"
											plain
											size="mini"
											:type="item.is_exception == 1 ? 'danger' : ''"
											@click="bindMarkException(item)"
										>{{ item.is_exception == 1 ? '取消异常' : '标记异常' }}</el-button>
									</div>
									<div class="order_info">
										<div class="col t1">
											<div
												v-for="(p, idx) in visibleProducts(item)"
												:key="p.id || idx"
												class="goods_row"
											>
												<img class="thumb" :src="p.thumb_img || defaultThumb" alt="" />
												<div class="goods_meta">
													<p class="title">{{ isHideOrderInfo ? '************' : (p.title || '—') }}</p>
													<p class="meta_line">{{ formatSkuAttrs(p.sku_attrs) || '—' }}</p>

													<p class="meta_line">商品ID：{{ p.product_id || '—' }}</p>
													<p class="meta_line">
														规格ID：{{ p.sku_id || '—' }}
														<a
															href="javascript:;"
															class="static_link"
															@click="onQueryRelative(item, p)"
														>{{ p.is_relative ? '查看永久关联' : '查询是否永久关联' }}</a>
													</p>
													<p class="meta_line relative_status_line">
														<span v-if="p.is_relative" class="rel_ok">
															已关联{{ p.combo_type === 2 ? '（组合）' : '' }}
															<span v-if="p.is_temporary_relative">·临时</span>
															· {{ p.source_sku_id }}
														</span>
														<span v-else class="rel_empty">未关联</span>
														<!-- <a href="javascript:;" class="details" @click="openRelative(item, p)">
															{{ p.is_relative ? '修改关联' : '直采关联' }}
														</a> -->
													</p>
												</div>
											</div>
											<a
												v-if="(item.product_count || 0) > 3"
												href="javascript:;"
												class="expand"
												@click="toggleExpand(item.id)"
											>{{ expanded[item.id] ? '收起' : '其余 ' + ((item.product_count || 0) - 3) + ' 件' }}</a>
										</div>
										<div class="col t2">
											<template v-if="item.products && item.products.length">
												<div v-for="(p, idx) in visibleProducts(item)" :key="'sp'+idx" class="price_block">
													<p>¥{{ fenToYuan(p.sale_price) }}</p>
													<p class="muted">x{{ p.sku_cnt }}</p>
												</div>
											</template>
											<p v-else>—</p>
										</div>
										<div class="col t3">
											<p>微店状态：{{ item.status_text || '—' }}</p>
											<p class="muted">采购状态：{{ purchaseStatusSummary(item) }}</p>
											<p class="buyer">
												买家信息：
												<i class="el-icon-view eye" title="查看/编辑收货信息" @click="onDecode(item)"></i>
												<span v-if="Number(item.purchase_decode_fail) === 1" class="decode_fail_tag">解密失败</span>
												<span class="buyer_mask">{{ item.receiver_name || '—' }} {{ item.receiver_phone || '' }}</span>
											</p>
										</div>
										<div class="col t4">
											<p>实付：¥{{ fenToYuan(item.order_price) }}</p>
											<p class="muted">运费：¥{{ fenToYuan(item.freight) }}</p>
										</div>
										<div class="col t5">
											<div class="text-gray">暂无退货信息</div>
										</div>
										<div class="col t6">
											<div class="goods_purchase_detail">
												<template v-if="getPurchaseGroups(item).length">
													<div
														v-for="(group, gidx) in getPurchaseGroups(item)"
														:key="'pg-'+item.id+'-'+group.key+'-'+gidx"
														class="purchase_order_block"
														:class="{ 'is-fail': group.has_fail }"
													>
														<div class="purchase_order_head">
															<span class="po_label">采购单{{ getPurchaseGroups(item).length > 1 ? (gidx + 1) : '' }}</span>
															<span
																v-if="group.alibaba_order_id"
																class="po_order_id order-id-link"
																@click.stop="openAlibabaOrderById(group.alibaba_order_id)"
															>{{ group.alibaba_order_id }}</span>
															<span v-else class="po_order_id muted">未下单</span>
															<span
																v-if="Number(group.address_sync_fail) === 1"
																class="address_sync_fail_tag"
																:title="group.address_sync_msg || '改地址同步失败'"
															>改地址同步失败</span>
															<span
																class="line_status_tag"
																v-if="group.status_text"
																:class="'st-'+group.status_code"
															>
																<span class="label">采购状态:</span>{{ group.status_text }}
															</span>
														</div>
														<div class="purchase_supplier" v-if="group.albb_seller_name || group.wangwang_account">
															<span class="label">上家旺旺:</span>
															<span class="name">{{ group.albb_seller_name || group.wangwang_account }}</span>
															<i
																class="el-icon-chat-dot-round purchase_icon"
																@click.stop="openAlibabaWangwangChat(group.albb_seller_name || group.wangwang_account)"
															></i>
														</div>
														<div
															v-for="(aline, aidx) in group.lines"
															:key="'ai-'+item.id+'-'+aline.id+'-'+aidx"
															class="purchase_product_card combo_item_card"
															:class="{ 'is-fail': aline.line_status == 90 || aline.line_status == 100 }"
														>
															<div
																class="card_img"
																:class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
																@click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
															>
																<img class="coverimg" :src="aline.product_img || defaultThumb" alt="">
															</div>
															<div class="card_body">
																<p class="card_title_row">
																	<span
																		class="card_title"
																		:class="{ 'is-link': aline.offer_id || aline.alibaba_goods_id }"
																		@click.stop="openAlibabaOfferDetail(aline.offer_id || aline.alibaba_goods_id)"
																	>{{ aline.product_name || aline.alibaba_goods_id || '-' }}</span>
																</p>
																<p class="card_sku">SKU: {{ aline.sku_spec_value || aline.alibaba_sku_id || '-' }} × {{ aline.qty_unit || 1 }}（采 {{ aline.buy_num || 1 }}）</p>
																<p class="card_fail_msg" v-if="aline.abb_purchase_msg">{{ aline.abb_purchase_msg }}</p>
															</div>
														</div>
														<div class="purchase_order_meta">
															<div
																v-if="hasPurchaseGroupAmount(group) || canCancelPurchaseGroup(item, group)"
																class="purchase_amount_grid"
															>
																<div class="amount_col amount_col_left">
																	<p v-if="hasPurchaseGroupAmount(group)">采购金额：{{ formatMoney(group.pay_amount) }}</p>
																	<p v-if="canCancelPurchaseGroup(item, group)">
																		<el-button
																			type="danger" plain size="mini"
																			class="cancel_group_btn"
																			@click.stop="delPurchaseGroup(item, group)"
																		>取消该组采购</el-button>
																	</p>
																</div>
																<div class="amount_col amount_col_right">
																	<p v-if="hasPurchaseGroupAmount(group)">运费：{{ formatMoney(group.shipping_fee) }}</p>
																	<p v-if="hasPurchaseGroupAmount(group)">合计：{{ formatMoney(group.total_amount) }}</p>
																</div>
															</div>
															<p v-for="(tn, tidx) in (group.tracking_list || [])" :key="'tn-'+item.id+'-'+gidx+'-'+tidx">
																运单：{{ tn.no }}<span v-if="tn.company">（{{ tn.company }}）</span>
															</p>
															<p v-if="group.express_no && !(group.tracking_list && group.tracking_list.length)">
																运单：{{ group.express_no }}<span v-if="group.express">（{{ group.express }}）</span>
															</p>
															<p
																v-if="isDeliverFailGroup(item, group)"
																class="card_fail_msg"
															>发货失败：{{ group.step_remark }}</p>
														</div>
													</div>
												</template>
												<template v-else>
													<div class="purchase_empty">暂无直采关联</div>
												</template>
											</div>
										</div>
										<div class="col t7">
											<p>
												<a href="javascript:;" class="details" @click="openRelativeForOrder(item)">
													{{ isOrderAlibabaLinked(item) ? '修改关联' : '直采关联' }}
												</a>
											</p>
											<p v-if="canPurchase(item)">
												<a href="javascript:;" class="details" @click="doPurchase(item)">厂家直采</a>
											</p>
											<p v-if="canCancelPurchase(item)">
												<a href="javascript:;" class="details" @click="doCancelPurchase(item)">取消采购</a>
											</p>
											<p v-if="canRepealPurchase(item)">
												<a href="javascript:;" class="details" @click="doRepealPurchase(item)">撤销采购</a>
											</p>
											<p v-if="canPayPurchase(item)">
												<a href="javascript:;" class="details" @click="doPayPurchase(item)">去支付</a>
											</p>
											<p v-if="canRefreshWxOrder(item)">
												<a
													href="javascript:;"
													class="details"
													:class="{ disabled: refreshingOrderId === (item.order_id || item.id) }"
													@click="doRefreshWxOrder(item)"
												>{{ refreshingOrderId === (item.order_id || item.id) ? '同步中...' : '同步微店' }}</a>
											</p>
											<p v-if="canRestore(item)">
												<a href="javascript:;" class="details" @click="doRestore(item)">恢复</a>
											</p>
											<p v-if="Number(item.can_manual_deliver) === 1">
												<a href="javascript:;" class="details" @click="openManualDeliver(item)">手动发货</a>
											</p>
											<p v-if="Number(item.can_update_delivery) === 1">
												<a href="javascript:;" class="details" @click="openUpdateDelivery(item)">修改物流</a>
											</p>
											<p v-if="canSoftDelete(item)">
												<a href="javascript:;" class="details danger"
													@click="doSoftDelete(item)">删除订单</a>
											</p>
										</div>
									</div>
									<div class="order_remarks">
										<div class="remarks_item">
											<p class="txt" :class="{ red: !!item.abb_purchase_remark }">采购备注：</p>
											<p class="remarks" :class="{ red: !!item.abb_purchase_remark }">{{ item.abb_purchase_remark || '—' }}</p>
										</div>
										<div class="remarks_item">
											<p class="txt">买家留言：</p>
											<p class="remarks">{{ item.buyer_remark || '—' }}</p>
										</div>
										<div class="remarks_item">
											<p class="txt">商家备注：</p>
											<p class="remarks">
												<span>{{ item.merchant_remark || '—' }}</span>
												<i
													v-if="item.merchant_notes_tag_color_info"
													class="el-icon-s-flag remark_flag"
													:style="{ color: item.merchant_notes_tag_color_info.color }"
												></i>
												<i class="el-icon-edit remark_edit" @click="openMerchantNotes(item)"></i>
											</p>
										</div>
									</div>
								</li>
								<li v-if="!loading && list.length === 0" class="empty">暂无订单</li>
							</ul>

							<Pagination
								v-show="total > 0"
								:total="total"
								:page.sync="page"
								:limit.sync="pageSize"
								@pagination="loadList"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>

		<syncWxOrder
			:show="syncDialogVisible"
			:sync-task="syncTask"
			@close="syncDialogVisible = false"
			@success="onSyncSuccess"
			@refresh-sync="refreshSync"
		/>

		<merchantNotesDialog
			:show="remarkDialog.show"
			:order-id="remarkDialog.orderId"
			:shop-id="remarkDialog.shopId"
			:wx-order-id="remarkDialog.wxOrderId"
			:init-notes="remarkDialog.notes"
			:init-tag-color="remarkDialog.tagColor"
			:tag-colors="arrTagColor"
			@close="remarkDialog.show = false"
			@complete="onRemarkSaved"
		/>

		<alibabaGoodsConnect ref="alibabaConnect" @saved="onRelativeSaved" />
		<batchAlibabaConnect ref="batchAlibabaConnect" @refresh="onBatchAlibabaConnectRefresh" />

		<el-dialog title="永久关联查询" :visible.sync="relativeQueryVisible" width="560px" append-to-body>
			<div v-loading="relativeQueryLoading">
				<template v-if="relativeQueryData">
					<p class="muted">店铺 {{ relativeQueryData.shop_id }} · 规格 {{ relativeQueryData.wx_sku_id }}</p>
					<p>
						类型：
						<span v-if="(relativeQueryData.alibaba_relative_lines || []).length >= 2">组合</span>
						<span v-else-if="(relativeQueryData.alibaba_relative_lines || []).length === 1">普通</span>
						<span v-else>未关联</span>
					</p>
					<ul class="relative_query_list">
						<li v-for="(line, idx) in (relativeQueryData.alibaba_relative_lines || [])" :key="idx">
							<p>{{ line.spec_value || line.alibaba_sku_id }}</p>
							<p class="muted">offer {{ line.alibaba_goods_id }} · sku {{ line.alibaba_sku_id }} · qty {{ line.qty }} · sort {{ line.sort }}</p>
						</li>
						<li v-if="!(relativeQueryData.alibaba_relative_lines || []).length" class="muted">无永久关联记录</li>
					</ul>
				</template>
			</div>
			<span slot="footer">
				<el-button size="small" @click="relativeQueryVisible = false">关闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="买家收货信息" :visible.sync="decodeVisible" width="560px" append-to-body @closed="onDecodeDialogClosed">
			<div v-loading="decodeLoading" class="decode_box">
				<el-form v-if="decodeForm" ref="decodeFormRef" :model="decodeForm" :rules="decodeRules" label-width="88px" size="small">
					<el-form-item label="地址信息">
						<el-input
							v-model="decodeAddressText"
							type="textarea"
							:rows="3"
							clearable
							placeholder="粘贴地址信息，点击智能识别按钮自动识别填充地址信息"
						/>
						<div style="margin-top: 8px">
							<el-button size="mini" :loading="decodeExplainLoading" @click="onExplainAddress">智能识别</el-button>
						</div>
					</el-form-item>
					<el-form-item label="收件人" prop="user_name">
						<el-input v-model="decodeForm.user_name" maxlength="64" placeholder="请输入收件人" />
					</el-form-item>
					<el-form-item label="电话" prop="tel_number">
						<el-input v-model="decodeForm.tel_number" maxlength="11" placeholder="11位手机号" />
					</el-form-item>
					<el-form-item label="省市区" prop="regionCodes" required>
						<el-cascader
							:key="'region-cas-' + regionCascaderKey"
							v-model="decodeForm.regionCodes"
							:props="regionCascaderProps"
							:options="regionOptions"
							clearable
							filterable
							style="width: 100%"
							placeholder="请选择省/市/区"
							@change="onRegionChange"
						/>
					</el-form-item>
					<el-form-item label="详细地址" prop="detail_info">
						<el-input v-model="decodeForm.detail_info" type="textarea" :rows="2" maxlength="256" placeholder="请输入详细地址" />
					</el-form-item>
					<template v-if="decodeVirtual && decodeVirtual.virtual_number">
						<el-form-item label="虚拟号">
							<span class="virtual">{{ decodeVirtual.virtual_number }}
								<span v-if="decodeVirtual.extension"> 分机 {{ decodeVirtual.extension }}</span>
							</span>
						</el-form-item>
						<p v-if="decodeVirtual.expiration" class="muted" style="margin: -8px 0 8px 88px">
							虚拟号过期：{{ formatTime(decodeVirtual.expiration) }}
						</p>
					</template>
					<p v-if="decodeMeta.decode_api_status === 0" class="muted" style="margin-left: 88px">当前店铺解密接口暂不可用，请人工核对并保存收货信息</p>
				</el-form>
			</div>
			<span slot="footer">
				<el-button size="small" @click="decodeVisible = false">取消</el-button>
				<el-button type="primary" size="small" :loading="decodeSaving" @click="onSaveDeliveryAddress">保存</el-button>
			</span>
		</el-dialog>

		<el-dialog title="导入买家信息" :visible.sync="addressImportVisible" width="640px" append-to-body @open="() => refreshAddressImport({ silent: true })">
			<div class="address_import_dialog">
				<div class="import_progress_line">
					<span class="sync_label">最新进度：</span>
					<span v-if="!addressImportTask" class="sync_muted">暂无导入任务</span>
					<span v-else>{{ addressImportTask.text }}</span>
					<el-button
						type="text"
						size="mini"
						class="import_refresh_btn"
						icon="el-icon-refresh"
						:loading="addressImportRefreshing"
						@click="onRefreshAddressImport"
					>刷新进度</el-button>
				</div>
				<p class="import_section_title">示例表格</p>
				<table class="import_sample_table">
					<thead>
						<tr><th>微店单号</th><th>地址信息</th></tr>
					</thead>
					<tbody>
						<tr>
							<td>3722xxxxxxxxxxxx</td>
							<td>张三 13800138000 广东省深圳市南山区科技园南路 xx 号</td>
						</tr>
					</tbody>
				</table>
				<p class="import_section_title">注意事项</p>
				<ol class="import_tips">
					<li>仅支持 .xlsx / .csv，单文件不超过 5000 行、小于 50MB。</li>
					<li>表头须含「微店单号」「地址信息」两列（顺序可对调）；其它列忽略。</li>
					<li>「地址信息」请填写含收件人、手机、省市区及详址的完整字符串；系统将异步解析后写入买家收货信息。</li>
					<li>同文件重复单号只保留最后一行；若当前批次仍有该单号待处理，将被本次内容覆盖。</li>
					<li>解析失败或信息不完整时，订单会标「解密失败」，且不会覆盖已有解密成功记录。</li>
					<li>关闭弹窗不影响后台继续处理；可随时点「刷新进度」查看最新结果。</li>
				</ol>
				<div class="import_upload_row">
					<input
						ref="addressImportFile"
						type="file"
						accept=".xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
						style="display:none"
						@change="onAddressImportFileChange"
					/>
					<el-button type="primary" size="small" :loading="addressImportUploading" @click="triggerAddressImportFile">选择文件并导入</el-button>
				</div>
			</div>
			<span slot="footer">
				<el-button size="small" @click="addressImportVisible = false">关闭</el-button>
			</span>
		</el-dialog>

		<markProblemOrder ref="markProblemOrder" />
		<manualDeliverDialog ref="manualDeliverDialog" />
		<updateDeliveryDialog ref="updateDeliveryDialog" />
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import myHead from '../../components/myHead/myhead'
import myFoot from '../../components/myFoot/myfoot'
import ucMenu from '../../components/ucenterMenu/ucmenu'
import Pagination from '../../components/pagination/pagination'
import syncWxOrder from './components/sync_wx_order/index.vue'
import merchantNotesDialog from './components/merchant_notes/index.vue'
import alibabaGoodsConnect from './components/alibaba_goods_connect/index.vue'
import batchAlibabaConnect from './components/batch_alibaba_connect/index.vue'
import markProblemOrder from './components/mark_problem_order/index.vue'
import manualDeliverDialog from './components/manual_deliver_dialog/index.vue'
import updateDeliveryDialog from './components/update_delivery_dialog/index.vue'

const PROVINCES = [
	'北京市','天津市','上海市','重庆市','河北省','山西省','辽宁省','吉林省','黑龙江省',
	'江苏省','浙江省','安徽省','福建省','江西省','山东省','河南省','湖北省','湖南省',
	'广东省','海南省','四川省','贵州省','云南省','陕西省','甘肃省','青海省','台湾省',
	'内蒙古自治区','广西壮族自治区','西藏自治区','宁夏回族自治区','新疆维吾尔自治区',
	'香港特别行政区','澳门特别行政区'
]

const DEFAULT_TAG_COLORS = [
	{ val: 0, text: '灰色', color: '#909399' },
	{ val: 1, text: '红色', color: '#F56C6C' },
	{ val: 2, text: '橙色', color: '#E6A23C' },
	{ val: 3, text: '绿色', color: '#67C23A' },
	{ val: 4, text: '蓝色', color: '#409EFF' },
]

export default {
	name: 'UcWxOrder',
	components: {
		myHead,
		myFoot,
		ucMenu,
		Pagination,
		syncWxOrder,
		merchantNotesDialog,
		alibabaGoodsConnect,
		batchAlibabaConnect,
		markProblemOrder,
		manualDeliverDialog,
		updateDeliveryDialog,
	},
	data() {
		return {
			loading: false,
			list: [],
			total: 0,
			page: 1,
			pageSize: 20,
			counts: {},
			purchaseCounts: {},
			arrProblemType: [],
			arrPurchaseStatus: [
				{ text: '全部订单', val: '', count_key: 'all', num: 0 },
				{ text: '待采购', val: 'wait_purchase', count_key: 'wait_purchase', num: 0 },
				{ text: '待支付', val: 105, count_key: 'wait_pay', num: 0 },
				{ text: '采购失败', val: 101, count_key: 'fail', num: 0 },
				{ text: '部分采购成功', val: 102, count_key: 'partial', num: 0 },
				{ text: '采购未发货', val: 110, count_key: 'wait_send', num: 0 },
				{ text: '发货失败', val: 120, count_key: 'upstream_sent', num: 0 },
				{ text: '24H需发货', val: 125, count_key: 'tab_24h', num: 0 },
				{ text: '微店已发货', val: 130, count_key: 'platform_sent', num: 0 },
				{ text: '超时未发货', val: 135, count_key: 'overdue', num: 0 },
				{ text: '完结', val: 150, count_key: 'done', num: 0 },
				{ text: '已删除', val: 999, count_key: 'deleted', num: 0 },
			],
			arrShop: [],
			groupList: [],
			arrProvince: PROVINCES,
			arrTagColor: DEFAULT_TAG_COLORS.slice(),
			createTimeRange: null,
			checkAll: false,
			checkList: [],
			expanded: {},
			searchData: this.emptySearch(),
			arrBizStatus: [],
			syncTask: null,
			syncRunningCount: 0,
			syncTimer: null,
			syncDialogVisible: false,
			refreshingOrderId: 0,
			addressImportTask: null,
			addressImportVisible: false,
			addressImportUploading: false,
			addressImportRefreshing: false,
			decodeVisible: false,
			decodeLoading: false,
			decodeSaving: false,
			decodeExplainLoading: false,
			decodeAddressText: '',
			decodeForm: null,
			decodeVirtual: null,
			decodeMeta: {
				order_id: 0,
				decode_api_status: 1,
				purchase_decode_fail: 0,
			},
			decodeCurrentItem: null,
			regionOptions: [],
			regionCascaderKey: 0,
			regionUseLazy: true,
			decodeRules: {
				user_name: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
				tel_number: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' },
				],
				regionCodes: [{
					type: 'array',
					required: true,
					validator: (rule, value, callback) => {
						if (value && value.length >= 3 && this.decodeForm && this.decodeForm.national_code) {
							callback()
							return
						}
						callback(new Error('请选择省市区'))
					},
					trigger: 'change',
				}],
				detail_info: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
			},
			remarkDialog: {
				show: false,
				orderId: 0,
				shopId: '',
				wxOrderId: '',
				notes: '',
				tagColor: 0,
			},
			relativeQueryVisible: false,
			relativeQueryLoading: false,
			relativeQueryData: null,
			isHideOrderInfo: false,
			defaultThumb: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><rect fill="#f2f2f2" width="60" height="60"/></svg>'),
		}
	},
	computed: {
		checkIndeterminate() {
			const n = this.checkList.length
			return n > 0 && n < this.list.length
		},
		regionCascaderProps() {
			const base = {
				value: 'code',
				label: 'name',
				children: 'children',
			}
			if (this.regionUseLazy) {
				return {
					...base,
					lazy: true,
					lazyLoad: this.loadRegionChildren,
				}
			}
			return {
				...base,
				lazy: false,
			}
		},
	},
	watch: {
		'searchData.shop_id'() {
			this.refreshSync()
		},
		list() {
			this.syncCheckState()
		},
	},
	created() {
		const isHideInfo = localStorage.getItem('isHideInfo')
		if (isHideInfo == 1) {
			this.isHideOrderInfo = true
		}
		this.loadShops()
		this.loadGroupList()
		this.loadList()
		this.refreshSync()
	},
	beforeDestroy() {
		this.stopSyncPolling()
	},
	methods: {
		...mapActions('wxshopOrder', [
			'getShopListAction',
			'getOrderListAction',
			'getSyncStatusAction',
			'getDeliveryAddressAction',
			'postDeliveryAddressAction',
			'postExplainAddressAction',
			'getAddressCodeChildrenAction',
			'postMarkExceptionAction',
			'getAddressImportProgressAction',
			'postAddressImportAction',
			'postOrderRefreshAction',
			'postOrderExportAction',
		]),
		...mapActions('wxshopRelative', [
			'getRelativeQueryAction',
		]),
		...mapActions('wxshopPurchase', [
			'postPurchaseBatAction',
			'postPurchaseCancelAction',
			'postPurchaseRepealAction',
			'postPurchasePayAction',
			'postPurchaseDeleteAction',
			'postPurchaseRestoreAction',
		]),
		...mapActions({
			getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
		}),
		/** 任务是否仍在进行中（需轮询） */
		isSyncInProgress(task) {
			if (!task) return false
			const st = Number(task.status)
			return st === 0 || st === 1
		},
		startSyncPolling() {
			if (this.syncTimer) return
			this.syncTimer = setInterval(() => {
				this.refreshSync()
				this.refreshAddressImport({ silent: true })
			}, 8000)
		},
		stopSyncPolling() {
			if (this.syncTimer) {
				clearInterval(this.syncTimer)
				this.syncTimer = null
			}
		},
		openSyncWxOrder() {
			this.syncDialogVisible = true
		},
		onSyncSuccess() {
			this.startSyncPolling()
			this.refreshSync()
		},
		openAddressImport() {
			this.addressImportVisible = true
			this.refreshAddressImport({ silent: true })
		},
		triggerAddressImportFile() {
			const input = this.$refs.addressImportFile
			if (input) {
				input.value = ''
				input.click()
			}
		},
		onAddressImportFileChange(e) {
			const file = e.target && e.target.files && e.target.files[0]
			if (!file) return
			const name = (file.name || '').toLowerCase()
			if (!name.endsWith('.xlsx') && !name.endsWith('.csv')) {
				this.$message.error('仅支持 xlsx / csv 文件')
				return
			}
			if (file.size >= 50 * 1024 * 1024) {
				this.$message.error('文件大小须小于 50MB')
				return
			}
			this.addressImportUploading = true
			this.postAddressImportAction({
				file,
				success: (res) => {
					this.addressImportUploading = false
					if (res.code !== 200) {
						this.$message.error(res.msg || '导入失败')
						return
					}
					const d = res.data || {}
					this.$message.success(
						(res.msg || '导入成功') +
						'（批次 ' + (d.batch_no || '') + '，受理 ' + (d.accepted || 0) + ' 条）'
					)
					this.refreshAddressImport({ silent: true })
					this.startSyncPolling()
					this.loadList()
				},
				error: () => {
					this.addressImportUploading = false
					this.$message.error('导入失败')
				},
			})
		},
		refreshAddressImport(options) {
			const silent = !(options && options.silent === false)
			if (!silent) {
				this.addressImportRefreshing = true
			}
			this.getAddressImportProgressAction({
				success: (res) => {
					if (!silent) this.addressImportRefreshing = false
					if (res.code !== 200) {
						if (!silent) this.$message.error(res.msg || '刷新进度失败')
						return
					}
					const prevPending = this.addressImportTask && Number(this.addressImportTask.pending) > 0
					this.addressImportTask = (res.data && res.data.task) || null
					const pending = this.addressImportTask && Number(this.addressImportTask.pending) > 0
					if (pending) {
						this.startSyncPolling()
					} else {
						this.maybeStopProgressPolling()
						if (prevPending) {
							this.loadList()
						}
					}
				},
				error: () => {
					if (!silent) {
						this.addressImportRefreshing = false
						this.$message.error('刷新进度失败')
					}
				},
			})
		},
		onRefreshAddressImport() {
			this.refreshAddressImport({ silent: false })
		},
		maybeStopProgressPolling() {
			const importPending = this.addressImportTask && Number(this.addressImportTask.pending) > 0
			if (this.syncRunningCount <= 0 && !importPending) {
				this.stopSyncPolling()
			}
		},
		emptySearch() {
			return {
				group_ids: [],
				shop_id: '',
				product_keyword: '',
				wx_order_id: '',
				alibaba_order_id: '',
				purchase_account: '',
				express_no: '',
				abb_purchase_remark: '',
				order_price_min: '',
				order_price_max: '',
				provinces: [],
				merchant_notes: '',
				merchant_notes_tag_colors: [],
				customer_notes: '',
				biz_status: '',
				purchase_biz_status: '',
				_static_return: '',
				problem_types: [],
				relative_status: '',
			}
		},
		buildQuery() {
			const q = {
				page: this.page,
				page_size: this.pageSize,
			}
			if (this.searchData.group_ids && this.searchData.group_ids.length) {
				q.group_ids = this.searchData.group_ids.join(',')
			}
			if (this.searchData.shop_id) q.shop_id = this.searchData.shop_id
			if (this.searchData.product_keyword) q.product_keyword = this.searchData.product_keyword
			if (this.searchData.wx_order_id) q.wx_order_id = this.searchData.wx_order_id
			if (this.searchData.alibaba_order_id) q.alibaba_order_id = this.searchData.alibaba_order_id
			if (this.searchData.purchase_account) q.purchase_account = this.searchData.purchase_account
			if (this.searchData.express_no) q.express_no = this.searchData.express_no
			if (this.searchData.abb_purchase_remark) q.abb_purchase_remark = this.searchData.abb_purchase_remark
			if (this.searchData.purchase_biz_status !== '' && this.searchData.purchase_biz_status != null) {
				q.purchase_biz_status = this.searchData.purchase_biz_status
			}
			if (this.searchData.relative_status) q.relative_status = this.searchData.relative_status
			if (this.searchData.problem_types && this.searchData.problem_types.length) {
				q.problem_types = this.searchData.problem_types.join(',')
			}
			if (this.searchData.merchant_notes) q.merchant_notes = this.searchData.merchant_notes
			if (this.searchData.customer_notes) q.customer_notes = this.searchData.customer_notes
			if (this.searchData.merchant_notes_tag_colors && this.searchData.merchant_notes_tag_colors.length) {
				q.merchant_notes_tag_colors = this.searchData.merchant_notes_tag_colors.join(',')
			}
			if (this.searchData.order_price_min !== '' && this.searchData.order_price_min != null) {
				q.order_price_min = this.searchData.order_price_min
			}
			if (this.searchData.order_price_max !== '' && this.searchData.order_price_max != null) {
				q.order_price_max = this.searchData.order_price_max
			}
			if (this.searchData.provinces && this.searchData.provinces.length) {
				q.provinces = this.searchData.provinces.join(',')
			}
			if (this.createTimeRange && this.createTimeRange.length === 2) {
				q.create_time_start = Math.floor(this.createTimeRange[0] / 1000)
				q.create_time_end = Math.floor(this.createTimeRange[1] / 1000)
			}
			return q
		},
		loadGroupList() {
			this.getShopBoardGroupList({
				data: {},
				success: (res) => {
					if (res.code === 200) {
						this.groupList = res.data || []
					} else {
						this.$message.error(res.message || '获取分组失败')
					}
				},
			})
		},
		onGroupChange() {
			if (this.$store.state.login.user_level == 9 && this.searchData.group_ids && this.searchData.group_ids.length) {
				this.searchData.group_ids = []
				this.$message.error('普通会员无法使用分组')
			}
		},
		loadShops() {
			this.getShopListAction({
				success: (res) => {
					if (res.code !== 200) return
					this.arrShop = (res.data && res.data.list) || []
				},
			})
		},
		loadList(done) {
			this.loading = true
			this.getOrderListAction({
				data: this.buildQuery(),
				success: (res) => {
					this.loading = false
					if (res.code !== 200) {
						this.$message.error(res.msg || '加载失败')
						if (typeof done === 'function') done(false)
						return
					}
					const data = res.data || {}
					this.list = data.list || []
					this.total = data.total || 0
					this.counts = data.counts || {}
					this.purchaseCounts = data.purchase_counts || {}
					if (data.purchase_tabs && data.purchase_tabs.length) {
						this.arrPurchaseStatus = data.purchase_tabs
					} else {
						this.arrPurchaseStatus = this.arrPurchaseStatus.map((t) => ({
							...t,
							num: this.purchaseCounts[t.count_key] || 0,
						}))
					}
					if (data.tag_colors && data.tag_colors.length) {
						this.arrTagColor = data.tag_colors
					}
					if (data.arr_problem_type && data.arr_problem_type.length) {
						this.arrProblemType = data.arr_problem_type
					}
					if (typeof done === 'function') done(true)
				},
				error: () => {
					this.loading = false
					if (typeof done === 'function') done(false)
				},
			})
		},
		openMerchantNotes(item) {
			this.remarkDialog = {
				show: true,
				orderId: item.order_id || item.id,
				shopId: item.shop_id || '',
				wxOrderId: item.wx_order_id || '',
				notes: item.merchant_remark || item.merchant_notes || '',
				tagColor: item.merchant_notes_tag_color != null ? item.merchant_notes_tag_color : 0,
			}
		},
		openRelative(order, product) {
			if (!product || !product.id) {
				this.$message.warning('缺少订单商品行')
				return
			}
			this.$refs.alibabaConnect && this.$refs.alibabaConnect.open({
				order_product_id: product.id,
				shop_id: order.shop_id || '',
				wx_product_id: product.product_id,
				wx_sku_id: product.sku_id,
			})
		},
		openRelativeForOrder(order) {
			const products = order.products || []
			if (!products.length) {
				this.$message.warning('订单无商品行')
				return
			}
			// 优先打开未关联行
			const target = products.find(p => !p.is_relative) || products[0]
			this.openRelative(order, target)
		},
		/** 整单是否已有直采关联（对齐星好货修改关联文案） */
		isOrderAlibabaLinked(item) {
			if (!item) return false
			if (Array.isArray(item.alibaba_items) && item.alibaba_items.length) return true
			const products = item.products || []
			return products.some(p => !!p.is_relative)
		},
		onRelativeSaved() {
			this.loadList()
		},
		syncCheckState() {
			const ids = new Set(this.list.map(i => i.id))
			this.checkList = this.checkList.filter(id => ids.has(id))
			this.checkAll = this.list.length > 0 && this.checkList.length === this.list.length
		},
		onCheckAll(val) {
			this.checkList = val ? this.list.map(i => i.id) : []
			this.checkAll = !!val
		},
		onCheckRow(id, val) {
			const idx = this.checkList.indexOf(id)
			if (val && idx < 0) this.checkList.push(id)
			if (!val && idx > -1) this.checkList.splice(idx, 1)
			this.checkAll = this.list.length > 0 && this.checkList.length === this.list.length
		},
		openBatchAlibabaConnect() {
			if (!this.checkList.length) {
				this.$message.warning('请先勾选订单')
				return
			}
			const byKey = new Map()
			for (const orderId of this.checkList) {
				const order = this.list.find(i => i.id === orderId)
				if (!order) continue
				const products = Array.isArray(order.products) ? order.products : []
				for (const p of products) {
					if (!p || !p.id) continue
					const shopId = String(order.shop_id || '')
					const skuId = p.sku_id != null && p.sku_id !== '' ? String(p.sku_id) : ''
					if (!skuId) continue
					const key = `${shopId}_${skuId}`
					if (!byKey.has(key)) {
						byKey.set(key, {
							_batchKey: key,
							shop_id: shopId,
							shop_name: order.shop_name || '',
							wx_product_id: p.product_id,
							wx_sku_id: p.sku_id,
							order_product_id: p.id,
							batch_order_product_ids: [p.id],
							product_name: p.title || '',
							product_pic: p.thumb_img || '',
							spec_value: this.formatSkuAttrs(p.sku_attrs) || '',
							is_relative: !!p.is_relative,
							source_sku_id: p.source_sku_id || '',
						})
					} else {
						const row = byKey.get(key)
						if (!row.batch_order_product_ids.includes(p.id)) {
							row.batch_order_product_ids.push(p.id)
						}
						if (p.is_relative) row.is_relative = true
						if (p.source_sku_id) row.source_sku_id = p.source_sku_id
					}
				}
			}
			const items = [...byKey.values()]
			if (!items.length) {
				this.$message.warning('勾选订单无商品规格')
				return
			}
			this.$refs.batchAlibabaConnect && this.$refs.batchAlibabaConnect.open(items)
		},
		onBatchAlibabaConnectRefresh() {
			this.loadList(() => {
				const batch = this.$refs.batchAlibabaConnect
				if (batch && batch.visible) {
					batch.syncSkuItemsFromList(this.list)
				}
			})
		},
		onPurchaseTip() {
			this.$message.info('请先完成厂家直采关联')
		},
		openManualDeliver(item) {
			if (Number(item.can_manual_deliver) !== 1) {
				this.$message.warning('当前订单不支持手动发货')
				return
			}
			const dialog = this.$refs.manualDeliverDialog
			if (!dialog) {
				return
			}
			dialog.open(item, () => {
				this.loadList()
			})
		},
		openUpdateDelivery(item) {
			if (Number(item.can_update_delivery) !== 1) {
				this.$message.warning('当前订单不支持修改物流')
				return
			}
			const dialog = this.$refs.updateDeliveryDialog
			if (!dialog) {
				return
			}
			dialog.open(item, () => {
				this.loadList()
			})
		},
		collectOrderProductIds(item) {
			// 列表行 id 即为商品行 id
			const id = Number(item && (item.order_product_id || item.id) || 0)
			if (id > 0) return [id]
			const products = (item && item.products) || []
			return products.map((p) => Number(p.id)).filter((pid) => pid > 0)
		},
		canPurchase(item) {
			if (!this.isOrderAlibabaLinked(item)) return false
			if (Number(item.is_abnormal || 0) > 0) return false
			if (Number(item.is_exception || 0) === 1) return false
			// 仅采购态=0 可直采
			if (Number(item.purchase_biz_status || 0) !== 0) return false
			const products = item.products || []
			if (products.some((p) => Number(p.delete_time) > 0)) return false
			const wxSt = Number(item.status || 0)
			// 1. 待发货(20)/部分发货(21) + 采购态0
			if (wxSt === 20 || wxSt === 21) return true
			// 2. 已发货(30) + 曾采购过 + 采购态0（采后发货再取消）
			if (wxSt === 30 && Number(item.abb_purchase_time || 0) > 0) return true
			return false
		},
		canCancelPurchase(item) {
			const st = Number(item.purchase_biz_status || 0)
			return st === 100 || st === 105 || st === 101 || st === 102
		},
		canRepealPurchase(item) {
			const st = Number(item.purchase_biz_status || 0)
			return st >= 110 && st < 150 && st !== 140
		},
		canPayPurchase(item) {
			const st = Number(item.purchase_biz_status || 0)
			return st === 100 || st === 105
		},
		canSoftDelete(item) {
			const products = item.products || []
			if (!products.length) return false
			if (products.every((p) => Number(p.delete_time) > 0)) return false
			const st = Number(item.purchase_biz_status || 0)
			return ![105, 110, 120, 140].includes(st)
		},
		canRestore(item) {
			const products = item.products || []
			return products.some((p) => Number(p.delete_time) > 0)
		},
		canRefreshWxOrder(item) {
			if (Number(item.status) === 200) return false
			const wxOid = String(item.wx_order_id || '')
			if (wxOid.endsWith('B')) return false
			const products = item.products || []
			if (products.length && products.every((p) => Number(p.delete_time) > 0)) return false
			if (Number(item.delete_time || 0) > 0) return false
			return true
		},
		doRefreshWxOrder(item) {
			if (!this.canRefreshWxOrder(item)) return
			const orderId = Number(item.order_id || 0)
			const payload = orderId > 0
				? { id: orderId }
				: { wx_order_id: item.wx_order_id, shop_id: item.shop_id }
			const loadingKey = orderId > 0 ? orderId : (item.order_id || item.id)
			if (this.refreshingOrderId === loadingKey) return
			this.refreshingOrderId = loadingKey
			this.postOrderRefreshAction({
				data: payload,
				success: (res) => {
					this.refreshingOrderId = 0
					if (res.code !== 200) {
						this.$message.error(res.msg || res.message || '同步失败')
						return
					}
					this.$message.success(res.msg || '同步成功')
					this.loadList()
				},
				error: () => {
					this.refreshingOrderId = 0
					this.$message.error('同步失败')
				},
			})
		},
		orderExport() {
			this.$confirm('确认导出订单操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					background: 'rgba(0, 0, 0, 0.7)',
				})
				const q = this.buildQuery()
				delete q.page
				delete q.page_size
				if (this.checkList.length) {
					q.ids = this.checkList.join(',')
				}
				this.postOrderExportAction({
					data: q,
					success: (res) => {
						loading.close()
						if (res.code !== 200) {
							this.$message.error(res.msg || res.message || '导出失败')
							return
						}
						const url = (res.data && (res.data.file_url || res.data)) || ''
						if (!url) {
							this.$message.error('未返回下载地址')
							return
						}
						// 隐藏 iframe 触发附件下载，避免整页跳转到 export-file
						const iframe = document.createElement('iframe')
						iframe.style.display = 'none'
						iframe.src = url
						document.body.appendChild(iframe)
						setTimeout(() => {
							try { document.body.removeChild(iframe) } catch (e) {}
						}, 60000)
						this.$message.success(res.msg || '导出成功，开始下载')
					},
					error: () => {
						loading.close()
						this.$message.error('导出请求失败')
					},
				})
			}).catch(() => {})
		},
		doPurchase(item) {
			if (Number(item.is_exception || 0) === 1) {
				this.$message.error('异常订单不支持采购，请先取消异常标记')
				return
			}
			if (Number(item.is_abnormal || 0) > 0) {
				this.$message.error('问题单不支持厂家直采，请先取消问题标记')
				return
			}
			const ids = this.collectOrderProductIds(item)
			if (!ids.length) {
				this.$message.warning('无商品行')
				return
			}
			const tip = '确认厂家直采？'
			this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
				const loading = this.$loading({
					lock: true,
					text: '采购中...',
					background: 'rgba(0, 0, 0, 0.7)',
				})
				this.postPurchaseBatAction({
					data: { order_product_ids: ids },
					success: (res) => {
						loading.close()
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '采购失败')
							return
						}
						const d = res.data || {}
						this.notifyPurchaseBatResult(d)
						const pay = (d.results || []).find((r) => r.pay_url)
						if (pay && pay.pay_url) window.open(pay.pay_url, '_blank')
						this.loadList()
					},
					error: () => {
						loading.close()
						this.$message.error('采购请求失败')
					},
				})
			}).catch(() => {})
		},
		batchPurchase() {
			if (!this.checkList.length) {
				this.$message.warning('请先勾选订单')
				return
			}
			const abnormalCount = this.list.filter(item => this.checkList.includes(item.id) && item.is_abnormal > 0).length
			if (abnormalCount > 0) {
				this.$message.error('所选订单包含问题单，问题单不支持厂家直采')
				return
			}
			const exceptionCount = this.list.filter(item => this.checkList.includes(item.id) && item.is_exception == 1).length
			if (exceptionCount > 0) {
				this.$message.error('所选订单包含异常订单，异常订单不支持采购')
				return
			}
			const ids = []
			this.list.forEach((item) => {
				if (this.checkList.includes(item.id) && this.canPurchase(item)) {
					ids.push(...this.collectOrderProductIds(item))
				}
			})
			if (!ids.length) {
				this.$message.warning('勾选订单中无可直采商品行')
				return
			}
			this.$confirm('确认批量厂家直采？', '提示', { type: 'warning' }).then(() => {
				const loading = this.$loading({
					lock: true,
					text: '采购中...',
					background: 'rgba(0, 0, 0, 0.7)',
				})
				this.postPurchaseBatAction({
					data: { order_product_ids: ids },
					success: (res) => {
						loading.close()
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '批量采购失败')
							return
						}
						this.notifyPurchaseBatResult(res.data || {})
						this.loadList()
					},
					error: () => {
						loading.close()
						this.$message.error('批量采购请求失败')
					},
				})
			}).catch(() => {})
		},
		bindMarkProblem(item) {
			this.$refs.markProblemOrder.open(item, this.arrProblemType, () => {
				this.loadList()
			})
		},
		bindBatchMarkProblem() {
			this.$refs.markProblemOrder.openBatch(this.checkList, this.arrProblemType, () => {
				this.loadList()
			})
		},
		bindMarkException(item) {
			const state = item.is_exception == 1 ? 0 : 1
			const actionText = state === 1 ? '标记为异常订单' : '取消异常标记'
			this.$confirm(`确认${actionText}？异常订单不参与自动采购和手动采购。`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.postMarkExceptionAction({
					data: { ids: String(item.id), state },
					success: (res) => {
						if (res.code == 200) {
							this.$message({ type: 'success', message: res.msg || res.message || '操作成功' })
							this.loadList()
						} else {
							this.$message({ type: 'error', message: res.msg || res.message || '操作失败' })
						}
					}
				})
			}).catch(() => {})
		},
		bindBatchMarkException() {
			if (!this.checkList.length) {
				this.$message.warning('请先勾选订单')
				return
			}
			this.$confirm('确认将所选订单标记为异常？异常订单不参与自动采购和手动采购。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.postMarkExceptionAction({
					data: { ids: this.checkList.join(','), state: 1 },
					success: (res) => {
						if (res.code == 200) {
							this.$message({ type: 'success', message: res.msg || res.message || '操作成功' })
							this.loadList()
						} else {
							this.$message({ type: 'error', message: res.msg || res.message || '操作失败' })
						}
					}
				})
			}).catch(() => {})
		},
		/** 厂家直采结果提示：fail_count>0 时附带 results 全部 msg */
		notifyPurchaseBatResult(d) {
			const success = Number(d.success_count) || 0
			const fail = Number(d.fail_count) || 0
			let text = '成功 ' + success + '，失败 ' + fail
			if (fail > 0) {
				const msgs = [...new Set(
					(d.results || [])
						.map((r) => (r && r.msg != null ? String(r.msg).trim() : ''))
						.filter(Boolean)
				)]
				if (msgs.length) {
					text += '\n' + msgs.join('\n')
				}
				this.$alert(text.replace(/\n/g, '<br/>'), '提示', {
					type: success > 0 ? 'warning' : 'error',
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
				})
				return
			}
			this.$message.success(text)
		},
		doCancelPurchase(item) {
			const ids = this.collectOrderProductIds(item)
			this.$confirm('确认取消未付采购？', '提示', { type: 'warning' }).then(() => {
				this.postPurchaseCancelAction({
					data: { order_product_ids: ids },
					success: (res) => {
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '取消失败')
							return
						}
						this.$message.success('已提交取消')
						this.loadList()
					},
				})
			}).catch(() => {})
		},
		/** 多组采购才显示「取消该组」；已发货/终态不可 */
		canCancelPurchaseGroup(item, group) {
			if (!item || !group) return false
			if (this.getPurchaseGroups(item).length <= 1) return false
			const oid = String(group.alibaba_order_id || '').trim()
			if (!oid) return false
			const orderSt = Number(item.status || 0)
			if (orderSt === 200) return false
			const aliStatus = String(group.alibaba_status || '').toLowerCase()
			if (['waitbuyerreceive', 'confirm_goods', 'success', 'cancel', 'terminated'].includes(aliStatus)) {
				return false
			}
			const refundStatus = String(group.refund_status || '').toLowerCase()
			if (['waitselleragree', 'waitbuyermodify', 'waitbuyersend', 'waitsellerreceive', 'refundsuccess'].includes(refundStatus)) {
				return false
			}
			const lines = Array.isArray(group.lines) ? group.lines : []
			if (!lines.length) return false
			if (lines.some((l) => [40, 50].includes(Number(l.line_status || 0)))) return false
			if (lines.every((l) => [90, 100].includes(Number(l.line_status || 0)))) return false
			return lines.every((l) => [0, 10, 20, 30].includes(Number(l.line_status || 0)))
		},
		hasPurchaseGroupAmount(group) {
			if (!group) return false
			return Number(group.pay_amount || 0) > 0
				|| Number(group.shipping_fee || 0) > 0
				|| Number(group.total_amount || 0) > 0
		},
		formatMoney(val) {
			const n = Number(val)
			if (!Number.isFinite(n)) return '0.00'
			return n.toFixed(2)
		},
		delPurchaseGroup(item, group) {
			const oid = String(group?.alibaba_order_id || '').trim()
			if (!oid) {
				this.$message.error('缺少采购单号')
				return
			}
			const ids = (Array.isArray(group.lines) ? group.lines : [])
				.map((l) => Number(l.order_product_id || 0))
				.filter((id) => id > 0)
			if (!ids.length) {
				this.$message.error('缺少商品行')
				return
			}
			const maxLine = Math.max(...(group.lines || []).map((l) => Number(l.line_status || 0)), 0)
			const useRepeal = maxLine >= 30
			const aliStatus = String(group?.alibaba_status || '').toLowerCase()
			const tip = aliStatus === 'waitsellersend' || useRepeal
				? '确认取消该卖家组采购？将申请 1688 退款，其它组不受影响。'
				: '确认取消该卖家组采购？（其它组不受影响）'
			this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
				const action = useRepeal ? this.postPurchaseRepealAction : this.postPurchaseCancelAction
				action({
					data: { order_product_ids: ids, alibaba_order_id: oid },
					success: (res) => {
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '取消失败')
							return
						}
						this.$message.success(useRepeal ? '已提交退款取消' : '已提交取消')
						this.loadList()
					},
				})
			}).catch(() => {})
		},
		doRepealPurchase(item) {
			const ids = this.collectOrderProductIds(item)
			this.$confirm('确认撤销已付采购？将自动申请退款（异步申请1688退款）。', '提示', { type: 'warning' }).then(() => {
				this.postPurchaseRepealAction({
					data: { order_product_ids: ids },
					success: (res) => {
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '撤销失败')
							return
						}
						this.$message.success('已提交待退款')
						this.loadList()
					},
				})
			}).catch(() => {})
		},
		doPayPurchase(item) {
			const ids = this.collectOrderProductIds(item)
			if (!ids.length) return
			this.postPurchasePayAction({
				data: { order_product_id: ids[0], retry_protocol: true },
				success: (res) => {
					if (res.code !== 200) {
						this.$message.error(res.message || res.msg || '获取支付链接失败')
						return
					}
					const url = (res.data && res.data.pay_url) || ''
					if (url) window.open(url, '_blank')
					else this.$message.warning('无支付链接')
					// 已重挂 step=100 重试免密，刷新列表看态
					this.loadList()
				},
			})
		},
		doSoftDelete(item) {
			const ids = this.collectOrderProductIds(item).filter((id) => {
				const p = (item.products || []).find((x) => Number(x.id) === id)
				return p && Number(p.delete_time) === 0
			})
			if (!ids.length) return
			this.$confirm('确认删除所选商品行？', '提示', { type: 'warning' }).then(() => {
				this.postPurchaseDeleteAction({
					data: { order_product_ids: ids },
					success: (res) => {
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '删除失败')
							return
						}
						this.$message.success('已删除')
						this.loadList()
					},
				})
			}).catch(() => {})
		},
		batchSoftDelete() {
			if (!this.checkList.length) {
				this.$message.warning('请先勾选订单')
				return
			}
			const ids = []
			this.list.forEach((item) => {
				if (this.checkList.includes(item.id) && this.canSoftDelete(item)) {
					ids.push(...this.collectOrderProductIds(item).filter((id) => {
						const p = (item.products || []).find((x) => Number(x.id) === id)
						return p && Number(p.delete_time) === 0
					}))
				}
			})
			if (!ids.length) {
				this.$message.warning('无可删除行')
				return
			}
			this.$confirm('确认批量删除？', '提示', { type: 'warning' }).then(() => {
				this.postPurchaseDeleteAction({
					data: { order_product_ids: ids },
					success: (res) => {
						if (res.code !== 200) {
							this.$message.error(res.message || res.msg || '删除失败')
							return
						}
						this.$message.success('已删除')
						this.loadList()
					},
				})
			}).catch(() => {})
		},
		doRestore(item) {
			const ids = this.collectOrderProductIds(item).filter((id) => {
				const p = (item.products || []).find((x) => Number(x.id) === id)
				return p && Number(p.delete_time) > 0
			})
			if (!ids.length) return
			this.postPurchaseRestoreAction({
				data: { order_product_ids: ids },
				success: (res) => {
					if (res.code !== 200) {
						this.$message.error(res.message || res.msg || '恢复失败')
						return
					}
					this.$message.success('已恢复')
					this.loadList()
				},
			})
		},
		/**
		 * 采购单详情：整单 alibaba_items 按 alibaba_order_id / 卖家组分组
		 */
		getPurchaseGroups(item) {
			if (!item) return []
			const lines = Array.isArray(item.alibaba_items) ? item.alibaba_items : []
			if (!lines.length) return []
			const map = {}
			lines.forEach((line) => {
				const oid = String(line.alibaba_order_id || '').trim()
				const gkey = String(line.seller_group_key || line.albb_seller_id || 'pending')
				const key = oid || ('wait_' + gkey)
				if (!map[key]) {
					map[key] = {
						key,
						alibaba_order_id: oid,
						seller_group_key: gkey,
						wangwang_account: String(line.wangwang_account || ''),
						albb_seller_name: String(line.albb_seller_name || line.wangwang_account || ''),
						lines: [],
						has_fail: false,
						status_text: '',
						status_code: 0,
						account_text: String(line.account_text || '厂家直采'),
						pay_amount: Number(line.pay_amount || 0),
						shipping_fee: Number(line.shipping_fee || 0),
						total_amount: Number(line.total_amount || 0),
						express: String(line.express || ''),
						express_no: String(line.express_no || ''),
						tracking_list: [],
						alibaba_status: String(line.alibaba_status || ''),
						refund_status: String(line.refund_status || ''),
						step: Number(line.step || 0),
						step_remark: String(line.step_remark || ''),
						address_sync_fail: Number(line.address_sync_fail || 0),
						address_sync_msg: String(line.address_sync_msg || ''),
					}
				}
				map[key].lines.push(line)
				if (Number(line.pay_amount || 0) > 0 || Number(line.shipping_fee || 0) > 0) {
					map[key].pay_amount = Number(line.pay_amount || 0)
					map[key].shipping_fee = Number(line.shipping_fee || 0)
					map[key].total_amount = Number(
						line.total_amount || (Number(line.pay_amount || 0) + Number(line.shipping_fee || 0))
					)
				}
				if (line.account_text) {
					map[key].account_text = String(line.account_text)
				}
				if (line.alibaba_status) {
					map[key].alibaba_status = String(line.alibaba_status)
				}
				if (line.refund_status) {
					map[key].refund_status = String(line.refund_status)
				}
				if (Number(line.step || 0) > 0) {
					map[key].step = Number(line.step || 0)
				}
				if (line.step_remark) {
					map[key].step_remark = String(line.step_remark)
				}
				if (Number(line.address_sync_fail || 0) === 1) {
					map[key].address_sync_fail = 1
					if (line.address_sync_msg) {
						map[key].address_sync_msg = String(line.address_sync_msg)
					}
				}
				if (line.express_no) {
					map[key].express_no = String(line.express_no)
					map[key].express = String(line.express || map[key].express || '')
				}
				if (Number(line.line_status) === 90 || Number(line.line_status) === 100) {
					map[key].has_fail = true
				}
				if (!map[key].albb_seller_name && (line.albb_seller_name || line.wangwang_account)) {
					map[key].albb_seller_name = String(line.albb_seller_name || line.wangwang_account)
					map[key].wangwang_account = map[key].albb_seller_name
				}
				const trackNo = String(line.tracking_no || line.express_no || '').trim()
				if (trackNo) {
					const exists = map[key].tracking_list.some((t) => t.no === trackNo)
					if (!exists) {
						map[key].tracking_list.push({
							no: trackNo,
							company: String(line.logistics_company || line.express || ''),
						})
					}
				}
				const st = Number(line.line_status || 0)
				if (!map[key].status_text || st === 90 || st === 100) {
					map[key].status_text = line.line_status_text || ''
					map[key].status_code = st
				}
			})
			return Object.values(map)
		},
		purchaseStatusSummary(item) {
			if (!item) return '—'
			const st = Number(item.purchase_biz_status || 0)
			const payMsg = String(item.abb_purchase_msg || '').trim()
			// 100/105 优先展示具体支付原因
			if ((st === 100 || st === 105) && payMsg) return payMsg
			if (item.purchase_biz_status_text) return item.purchase_biz_status_text
			const groups = this.getPurchaseGroups(item)
			if (!groups.length) return '—'
			const texts = groups.map(g => g.status_text).filter(Boolean)
			if (!texts.length) return '—'
			return [...new Set(texts)].join(' / ')
		},
		/** D16：120 && step=500 && step_remark */
		isDeliverFailGroup(item, group) {
			if (!item || !group) return false
			const biz = Number(item.purchase_biz_status || 0)
			const step = Number(group.step || 0)
			const remark = String(group.step_remark || '').trim()
			return biz === 120 && step === 500 && remark !== ''
		},
		openAlibabaOrderById(orderId) {
			const id = String(orderId || '').trim()
			if (!id) return
			const url = `https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=${encodeURIComponent(id)}`
			window.open(url, '_blank')
		},
		openAlibabaOfferDetail(offerId) {
			const id = String(offerId || '').trim()
			if (!id) return
			window.open(`https://detail.1688.com/offer/${id}.html?offerId=${id}`, '_blank')
		},
		openAlibabaWangwangChat(wangwangAccount) {
			const account = String(wangwangAccount || '').trim()
			if (!account) {
				this.$message.warning('暂无上家旺旺')
				return
			}
			const wangwangId = account.replace(/^cnalichn/i, '')
			const touid = encodeURIComponent('cnalichn' + wangwangId)
			const url = `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`
			window.open(url, '_blank')
		},
		onQueryRelative(order, product) {
			if (!order.shop_id || !product.sku_id) {
				this.$message.warning('缺少店铺或规格信息')
				return
			}
			this.relativeQueryVisible = true
			this.relativeQueryLoading = true
			this.relativeQueryData = null
			this.getRelativeQueryAction({
				data: {
					shop_id: order.shop_id,
					wx_sku_id: product.sku_id,
				},
				success: (res) => {
					this.relativeQueryLoading = false
					if (res.code !== 200) {
						this.$message.error(res.msg || '查询失败')
						return
					}
					this.relativeQueryData = res.data || {}
				},
				error: () => {
					this.relativeQueryLoading = false
					this.$message.error('查询失败')
				},
			})
		},
		onRemarkSaved(data) {
			const id = data && data.order_id
			if (!id) {
				this.loadList()
				return
			}
			const row = this.list.find(i => i.id === id)
			if (!row) {
				this.loadList()
				return
			}
			const notes = data.merchant_notes != null ? data.merchant_notes : data.merchant_remark
			this.$set(row, 'merchant_remark', notes || null)
			this.$set(row, 'merchant_notes', notes || null)
			this.$set(row, 'merchant_notes_tag_color', data.merchant_notes_tag_color)
			this.$set(row, 'merchant_notes_tag_color_info', data.merchant_notes_tag_color_info || null)
			if (row.order_detail) {
				this.$set(row.order_detail, 'merchant_notes', notes || null)
				this.$set(row.order_detail, 'merchant_notes_tag_color', data.merchant_notes_tag_color)
			}
		},
		refreshSync() {
			// 弹窗进度展示商家最新任务，不跟列表店铺筛选项绑定
			this.getSyncStatusAction({
				data: {},
				success: (res) => {
					if (res.code !== 200) return
					const prevRunning = this.syncRunningCount > 0
					this.syncTask = (res.data && res.data.task) || null
					this.syncRunningCount = Number((res.data && res.data.running_count) || 0)
					// 兼容：无 running_count 时按当前 task 状态
					if (res.data && res.data.running_count == null) {
						this.syncRunningCount = this.isSyncInProgress(this.syncTask) ? 1 : 0
					}
					if (this.syncRunningCount > 0) {
						this.startSyncPolling()
					} else {
						this.maybeStopProgressPolling()
						if (prevRunning) {
							this.loadList()
						}
					}
				},
			})
			this.refreshAddressImport({ silent: true })
		},
		onSearch() {
			this.page = 1
			this.loadList()
			this.refreshSync()
		},
		onReset() {
			this.searchData = this.emptySearch()
			this.createTimeRange = null
			this.page = 1
			this.loadList()
			this.refreshSync()
		},
		isPurchaseTabCountHidden(tab) {
			if (!tab) return true
			if (tab.hide_count || tab.count_key === 'done' || tab.count_key === 'deleted') return true
			if (tab.val === '' || tab.count_key === 'all') return true
			return !((tab.num || this.purchaseCounts[tab.count_key] || 0) > 0)
		},
		onTab(val) {
			this.searchData.purchase_biz_status = val
			this.page = 1
			this.loadList()
		},
		onDecode(item) {
			this.decodeVisible = true
			this.decodeLoading = true
			this.decodeSaving = false
			this.decodeExplainLoading = false
			this.decodeAddressText = ''
			this.decodeForm = null
			this.decodeVirtual = null
			this.decodeCurrentItem = item
			this.regionOptions = []
			this.regionUseLazy = true
			this.regionCascaderKey += 1
			this.decodeMeta = {
				order_id: item.order_id || item.id,
				decode_api_status: 1,
				purchase_decode_fail: Number(item.purchase_decode_fail) || 0,
			}
			this.getDeliveryAddressAction({
				data: { id: item.order_id || item.id },
				success: (res) => {
					if (res.code !== 200) {
						this.decodeLoading = false
						this.$message.error(res.msg || '获取收货信息失败')
						// 仍打开空表单供人工填写
						this.decodeForm = this.emptyDecodeForm()
						return
					}
					const data = res.data || {}
					const info = data.address_info || {}
					this.decodeVirtual = data.virtual_number_info || null
					this.decodeMeta = {
						order_id: data.order_id || (item.order_id || item.id),
						decode_api_status: Number(data.decode_api_status) === 0 ? 0 : 1,
						purchase_decode_fail: Number(data.purchase_decode_fail) || 0,
					}
					if (Number(data.purchase_decode_fail) === 1 && item) {
						this.$set(item, 'purchase_decode_fail', 1)
					}
					this.decodeForm = {
						user_name: info.user_name || '',
						tel_number: info.tel_number || '',
						detail_info: info.detail_info || '',
						province_name: info.province_name || '',
						city_name: info.city_name || '',
						county_name: info.county_name || '',
						national_code: info.national_code ? Number(info.national_code) : 0,
						regionCodes: [],
					}
					const codes = Array.isArray(data.region_codes)
						? data.region_codes.map((c) => Number(c)).filter((c) => c > 0)
						: []
					if (codes.length >= 3) {
						this.applyRegionCodes(codes.slice(0, 3)).finally(() => {
							this.decodeLoading = false
						})
					} else {
						this.decodeLoading = false
					}
				},
				error: () => {
					this.decodeLoading = false
					this.decodeForm = this.emptyDecodeForm()
					this.$message.error('获取收货信息失败，可人工填写后保存')
				},
			})
		},
		emptyDecodeForm() {
			return {
				user_name: '',
				tel_number: '',
				detail_info: '',
				province_name: '',
				city_name: '',
				county_name: '',
				national_code: 0,
				regionCodes: [],
			}
		},
		onDecodeDialogClosed() {
			this.decodeForm = null
			this.decodeVirtual = null
			this.decodeCurrentItem = null
			this.decodeSaving = false
			this.decodeExplainLoading = false
			this.decodeAddressText = ''
			this.regionOptions = []
			this.regionUseLazy = true
			this.regionCascaderKey += 1
		},
		resetRegionCascaderLazy() {
			this.regionUseLazy = true
			this.regionOptions = []
			this.regionCascaderKey += 1
		},
		onExplainAddress() {
			const text = (this.decodeAddressText || '').trim()
			if (!text) {
				this.$message.warning('请输入地址信息')
				return
			}
			if (!this.decodeForm) {
				this.decodeForm = this.emptyDecodeForm()
			}
			this.decodeExplainLoading = true
			this.postExplainAddressAction({
				data: { address_text: text },
				success: (res) => {
					if (res.code !== 200) {
						this.decodeExplainLoading = false
						this.$message.error(res.msg || '识别失败')
						return
					}
					const data = res.data || {}
					this.decodeForm.user_name = data.user_name || ''
					this.decodeForm.tel_number = data.tel_number || ''
					this.decodeForm.province_name = data.province_name || ''
					this.decodeForm.city_name = data.city_name || ''
					this.decodeForm.county_name = data.county_name || ''
					this.decodeForm.detail_info = data.detail_info || ''
					this.decodeForm.national_code = data.national_code ? Number(data.national_code) : 0
					const codes = Array.isArray(data.region_codes) ? data.region_codes.map((c) => Number(c)).filter((c) => c > 0) : []
					if (codes.length >= 3) {
						this.applyRegionCodes(codes.slice(0, 3)).then((ok) => {
							this.decodeExplainLoading = false
							if (ok) {
								this.$message.success('识别成功')
							} else {
								this.$message.warning('已填充文本，省市区请手动选择')
							}
						})
					} else {
						this.decodeForm.regionCodes = []
						this.resetRegionCascaderLazy()
						this.decodeExplainLoading = false
						this.$message.warning('已填充文本，省市区编码未完全匹配，请手动选择省市区')
					}
				},
				error: () => {
					this.decodeExplainLoading = false
					this.$message.error('识别失败')
				},
			})
		},
		/** 拉取某级行政编码列表 */
		fetchRegionList(parentCode) {
			return new Promise((resolve) => {
				this.getAddressCodeChildrenAction({
					data: { parent_code: parentCode },
					success: (res) => {
						const list = (res && res.code === 200 && res.data && res.data.list) ? res.data.list : []
						resolve((list || []).map((row) => ({
							code: Number(row.code),
							name: row.name,
							level: Number(row.level) || 0,
							leaf: Number(row.level) >= 3,
						})))
					},
					error: () => resolve([]),
				})
			})
		},
		/**
		 * 懒加载无法直接 v-model 回显：关掉 lazy，灌入完整路径树后再选中.
		 * @param {number[]} codes
		 * @returns {Promise<boolean>}
		 */
		applyRegionCodes(codes) {
			const path = (codes || []).map((c) => Number(c)).filter((c) => c > 0)
			if (path.length < 3 || !this.decodeForm) {
				return Promise.resolve(false)
			}
			const [pCode, cCode, aCode] = path
			return this.fetchRegionList(0).then((provinces) => {
				if (!provinces.length) return false
				return this.fetchRegionList(pCode).then((cities) => {
					return this.fetchRegionList(cCode).then((counties) => {
						const province = provinces.find((p) => p.code === pCode)
						const city = cities.find((c) => c.code === cCode)
						const county = counties.find((d) => d.code === aCode)
						if (!province || !city || !county) {
							this.decodeForm.regionCodes = []
							this.resetRegionCascaderLazy()
							return false
						}
						// 非懒模式：全省列表 + 当前省/市挂齐子级，保证回显；其它省可点开需再识别或清空后懒加载
						const options = provinces.map((p) => {
							if (p.code !== pCode) {
								return { code: p.code, name: p.name }
							}
							return {
								code: p.code,
								name: p.name,
								children: cities.map((c) => {
									if (c.code !== cCode) {
										return { code: c.code, name: c.name }
									}
									return {
										code: c.code,
										name: c.name,
										children: counties.map((d) => ({
											code: d.code,
											name: d.name,
										})),
									}
								}),
							}
						})
						this.regionUseLazy = false
						this.regionOptions = options
						this.regionCascaderKey += 1
						return new Promise((resolve) => {
							this.$nextTick(() => {
								this.decodeForm.province_name = province.name
								this.decodeForm.city_name = city.name
								this.decodeForm.county_name = county.name
								this.decodeForm.national_code = aCode
								this.decodeForm.regionCodes = [pCode, cCode, aCode]
								resolve(true)
							})
						})
					})
				})
			}).catch(() => false)
		},
		loadRegionChildren(node, resolve) {
			const parentCode = node.level === 0 ? 0 : Number(node.value)
			this.fetchRegionList(parentCode).then((nodes) => resolve(nodes))
		},
		onRegionChange(codes) {
			if (!this.decodeForm) return
			if (!codes || codes.length < 3) {
				this.decodeForm.province_name = ''
				this.decodeForm.city_name = ''
				this.decodeForm.county_name = ''
				this.decodeForm.national_code = 0
				// 清空后恢复懒加载，便于重新选全国省市区
				if (!codes || !codes.length) {
					this.resetRegionCascaderLazy()
					this.decodeForm.regionCodes = []
				}
				return
			}
			this.$nextTick(() => {
				const nodes = this.findCascaderCheckedNodes()
				if (nodes && nodes.length >= 3) {
					this.decodeForm.province_name = nodes[0].label || ''
					this.decodeForm.city_name = nodes[1].label || ''
					this.decodeForm.county_name = nodes[2].label || ''
				} else if (!this.regionUseLazy && this.regionOptions.length) {
					// 非懒模式从 options 取名
					const p = this.regionOptions.find((x) => x.code === Number(codes[0]))
					const c = p && p.children ? p.children.find((x) => x.code === Number(codes[1])) : null
					const d = c && c.children ? c.children.find((x) => x.code === Number(codes[2])) : null
					if (p) this.decodeForm.province_name = p.name
					if (c) this.decodeForm.city_name = c.name
					if (d) this.decodeForm.county_name = d.name
				}
				this.decodeForm.national_code = Number(codes[2]) || 0
			})
		},
		findCascaderCheckedNodes() {
			const form = this.$refs.decodeFormRef
			if (!form) return null
			const cascader = this.findChildCascader(form)
			if (!cascader || !cascader.getCheckedNodes) return null
			const nodes = cascader.getCheckedNodes()
			return nodes && nodes[0] ? nodes[0].pathNodes : null
		},
		findChildCascader(vm) {
			if (!vm || !vm.$children) return null
			for (let i = 0; i < vm.$children.length; i++) {
				const child = vm.$children[i]
				if (child && child.getCheckedNodes) return child
				const nested = this.findChildCascader(child)
				if (nested) return nested
			}
			return null
		},
		onSaveDeliveryAddress() {
			if (!this.decodeForm) return
			const formRef = this.$refs.decodeFormRef
			const doSave = () => {
				const codes = this.decodeForm.regionCodes || []
				if (codes.length < 3 || !this.decodeForm.national_code) {
					this.$message.error('请选择省市区')
					return
				}
				const nodes = this.findCascaderCheckedNodes()
				if (nodes && nodes.length >= 3) {
					this.decodeForm.province_name = nodes[0].label || this.decodeForm.province_name
					this.decodeForm.city_name = nodes[1].label || this.decodeForm.city_name
					this.decodeForm.county_name = nodes[2].label || this.decodeForm.county_name
					this.decodeForm.national_code = Number(nodes[2].value) || this.decodeForm.national_code
				}
				if (!this.decodeForm.province_name || !this.decodeForm.city_name || !this.decodeForm.county_name) {
					this.$message.error('请选择省市区')
					return
				}
				this.decodeSaving = true
				this.postDeliveryAddressAction({
					data: {
						id: this.decodeMeta.order_id,
						user_name: this.decodeForm.user_name,
						tel_number: this.decodeForm.tel_number,
						province_name: this.decodeForm.province_name,
						city_name: this.decodeForm.city_name,
						county_name: this.decodeForm.county_name,
						detail_info: this.decodeForm.detail_info,
						national_code: this.decodeForm.national_code,
					},
					success: (res) => {
						this.decodeSaving = false
						if (res.code !== 200) {
							this.$message.error(res.msg || '保存失败')
							return
						}
						this.$message.success('收货信息已保存')
						if (this.decodeCurrentItem) {
							this.$set(this.decodeCurrentItem, 'purchase_decode_fail', 0)
						}
						this.decodeVisible = false
					},
					error: () => {
						this.decodeSaving = false
						this.$message.error('保存失败')
					},
				})
			}
			if (formRef && formRef.validate) {
				formRef.validate((ok) => {
					if (!ok) return
					doSave()
				})
			} else {
				doSave()
			}
		},
		visibleProducts(item) {
			const products = item.products || []
			if (this.expanded[item.id]) return products
			return products.slice(0, 3)
		},
		toggleExpand(id) {
			this.$set(this.expanded, id, !this.expanded[id])
		},
		showOrderInfo() {
			const isHideInfo = localStorage.getItem('isHideInfo')
			if (isHideInfo == 1) {
				localStorage.setItem('isHideInfo', 0)
				this.isHideOrderInfo = false
			} else {
				localStorage.setItem('isHideInfo', 1)
				this.isHideOrderInfo = true
			}
		},
		fenToYuan(fen) {
			const n = Number(fen || 0)
			return (n / 100).toFixed(2)
		},
		formatTime(ts) {
			if (!ts) return '—'
			const d = new Date(Number(ts) * 1000)
			const p = (n) => (n < 10 ? '0' + n : '' + n)
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
				+ ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
		},
		formatSkuAttrs(attrs) {
			if (!attrs) return ''
			if (typeof attrs === 'string') {
				try { attrs = JSON.parse(attrs) } catch (e) { return attrs }
			}
			if (!Array.isArray(attrs)) return ''
			return attrs.map(a => {
				if (typeof a === 'string') return a
				const key = a.attr_key || a.key || a.name || ''
				const val = a.attr_value || a.value || ''
				if (key && val) return key + ':' + val
				return val || key
			}).filter(Boolean).join('；')
		},
		productCode(p) {
			if (!p) return '—'
			const code = p.out_sku_id || p.out_product_id || ''
			return code || '—'
		},
		formatAddress(info) {
			if (!info) return '—'
			return [info.province_name, info.city_name, info.county_name, info.detail_info, info.house_number]
				.filter(Boolean).join(' ')
		},
		copyText(text) {
			if (!text) return
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(() => this.$message.success('已复制'))
				return
			}
			const input = document.createElement('input')
			input.value = text
			document.body.appendChild(input)
			input.select()
			document.execCommand('copy')
			document.body.removeChild(input)
			this.$message.success('已复制')
		},
	},
}
</script>

<style scoped>
.wx_order_page { padding: 40px; }
.fb { font-weight: bold; font-size: 16px; margin-bottom: 12px; }
.sync_label { color: #333; font-weight: 600; margin-right: 6px; }
.sync_muted { color: #999; }
.address_import_dialog .import_progress_line { margin-bottom: 12px; font-size: 13px; }
.import_refresh_btn { margin-left: 8px; padding: 0; vertical-align: baseline; }
.address_import_dialog .import_section_title {
	margin: 14px 0 8px;
	font-weight: 600;
	color: #303133;
}
.import_sample_table {
	width: 100%;
	border-collapse: collapse;
	font-size: 12px;
}
.import_sample_table th,
.import_sample_table td {
	border: 1px solid #ebeef5;
	padding: 8px 10px;
	text-align: left;
	vertical-align: top;
}
.import_sample_table th { background: #f5f7fa; color: #606266; }
.import_tips {
	margin: 0;
	padding-left: 18px;
	color: #606266;
	font-size: 12px;
	line-height: 1.7;
}
.import_upload_row { margin-top: 16px; }

.select_wrap {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 0 12px;
}
.select_wrap .w290 {
	width: 290px;
	margin-top: 14px;
	position: relative;
}
.select_wrap .label_title {
	width: 88px;
	height: 100%;
	margin: 0;
	font-size: 12px;
	color: #666;
	display: flex;
	align-items: center;
	padding-left: 6px;
	box-sizing: border-box;
	white-space: nowrap;
	pointer-events: none;
}
.select_wrap >>> .el-input__prefix {
	display: flex;
	align-items: center;
}
.select_wrap >>> .el-input--prefix .el-input__inner,
.select_wrap >>> .el-input .el-input__inner {
	padding-left: 88px !important;
	height: 34px;
	line-height: 34px;
	font-size: 12px;
}
/* 多选 tags 避开左侧 label，避免与 prefix 重叠 */
.select_wrap >>> .el-select .el-select__tags {
	left: 88px;
	max-width: calc(100% - 120px);
}
.search-amount-range {
	display: flex;
	align-items: center;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	height: 34px;
	padding: 0 8px;
	box-sizing: border-box;
	position: relative;
}
.search-amount-range .label_title {
	width: auto;
	padding-left: 0;
	margin-right: 8px;
	flex-shrink: 0;
}
.search-amount-range .amount-inputs { display: flex; align-items: center; flex: 1; min-width: 0; }
.search-amount-range .amount-input >>> .el-input__inner {
	padding-left: 6px !important;
	border: none;
	height: 32px;
	box-shadow: none;
}
.amount-sep { color: #999; padding: 0 4px; }
.select_btns { margin-top: 14px; display: flex; align-items: center; gap: 8px; }
.select_wrap >>> .el-date-editor { width: 290px !important; margin-top: 14px;height: 34px;line-height: 34px; }

.tabs_wrap {
	display: flex;
	flex-wrap: wrap;
	margin: 16px 0 8px;
	border-bottom: 1px solid #eee;
}
.tabs_wrap .tab {
	padding: 8px 16px;
	cursor: pointer;
	font-size: 13px;
	color: #666;
	margin: 0 4px 0 0;
}
.tabs_wrap .tab.active {
	color: #f0413e;
	border-bottom: 2px solid #f0413e;
	font-weight: 600;
}
.tab_badge >>> .el-badge__content { transform: translateY(-2px) translateX(8px); }

.totals_btn {
	display: flex;
	align-items: center;
	margin: 12px 0;
	font-size: 13px;
}
.totals_btn .total_text{
	margin-right: 10px;
}
.btn_group { display: flex; flex-wrap: wrap; gap: 6px; }

.list_title {
	display: flex;
	align-items: center;
	background: #f7f7f7;
	padding: 10px 8px;
	font-size: 12px;
	color: #666;
	font-weight: 600;
}
.list_title .checkall { width: 36px; }
.list_title .t1, .order_info .t1 { width: 28%; }
.list_title .t1 .title_eye {
	font-size: 14px;
	margin-left: 5px;
	cursor: pointer;
	vertical-align: middle;
}
.list_title .t2, .order_info .t2 { width: 10%; }
.list_title .t3, .order_info .t3 { width: 14%; }
.list_title .t4, .order_info .t4 { width: 10%; }
.list_title .t5, .order_info .t5 { width: 12%; }
.list_title .t6, .order_info .t6 {
	width: 16%;
}
.list_title .t6 {
	display: flex;
	align-items: center;
}
.list_title .t6 .purchase_col_tip {
	margin-left: 4px;
	font-size: 14px;
	color: #909399;
	cursor: pointer;
}
.list_title .t7, .order_info .t7 { width: 10%; }
.order_info .t7 > p {
	margin: 0 0 5px;
}
.order_info .t7 > p:last-child {
	margin-bottom: 0;
}

.order_info .goods_purchase_detail {
	width: 100%;
	text-align: left;
	line-height: 1.4;
}
.order_info .goods_purchase_detail .purchase_order_block {
	margin-bottom: 10px;
	padding: 8px;
	background: #fafafa;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
}
.order_info .goods_purchase_detail .purchase_order_block:last-of-type {
	margin-bottom: 8px;
}
.order_info .goods_purchase_detail .purchase_order_block.is-fail {
	background: #fff7f7;
	border-color: #ffccc7;
}
.order_info .goods_purchase_detail .purchase_order_head {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
	margin-bottom: 6px;
}
.order_info .goods_purchase_detail .po_label {
	font-weight: 600;
	color: #333;
}
.order_info .goods_purchase_detail .po_order_id {
	font-size: 12px;
	color: #666;
	word-break: break-all;
}
.order_info .goods_purchase_detail .po_order_id.order-id-link {
	color: #409eff;
	cursor: pointer;
}
.order_info .goods_purchase_detail .po_order_id.order-id-link:hover {
	text-decoration: underline;
}
.order_info .goods_purchase_detail .po_order_id.muted {
	color: #bbb;
}
.order_info .goods_purchase_detail .purchase_order_meta {
	margin-top: 4px;
	font-size: 12px;
	color: #666;
	line-height: 1.5;
}
.order_info .goods_purchase_detail .purchase_order_meta p {
	margin: 2px 0;
}
.order_info .goods_purchase_detail .purchase_amount_grid {
	display: flex;
	align-items: flex-start;
	width: 100%;
}
.order_info .goods_purchase_detail .purchase_amount_grid .amount_col {
	width: 50%;
	text-align: left;
	box-sizing: border-box;
}
.order_info .goods_purchase_detail .purchase_amount_grid .cancel_group_btn {
	padding: 4px 8px;
}
.order_info .goods_purchase_detail .purchase_supplier {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	margin-bottom: 6px;
	font-size: 12px;
	color: #666;
}
.order_info .goods_purchase_detail .line_status_tag .label {
	margin-right: 2px;
}
.order_info .goods_purchase_detail .purchase_supplier .label {
	color: #999;
}
.order_info .goods_purchase_detail .purchase_supplier .name {
	color: #333;
	word-break: break-all;
}
.order_info .goods_purchase_detail .purchase_supplier .purchase_icon {
	margin-left: 6px;
	font-size: 14px;
	color: #1966ff;
	cursor: pointer;
}
.order_info .goods_purchase_detail .purchase_product_card {
	display: flex;
	gap: 8px;
	margin-bottom: 6px;
	padding: 6px;
	background: #fff;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
}
.order_info .goods_purchase_detail .purchase_product_card .card_img {
	width: 44px;
	height: 44px;
	flex-shrink: 0;
	overflow: hidden;
	border-radius: 2px;
	background: #f2f2f2;
}
.order_info .goods_purchase_detail .purchase_product_card .card_img img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.order_info .goods_purchase_detail .purchase_product_card .card_body {
	flex: 1;
	min-width: 0;
}
.order_info .goods_purchase_detail .purchase_product_card .card_title {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	color: #333;
	line-height: 1.35;
}
.order_info .goods_purchase_detail .purchase_product_card .card_img.is-link,
.order_info .goods_purchase_detail .purchase_product_card .card_title.is-link {
	cursor: pointer;
}
.order_info .goods_purchase_detail .purchase_product_card .card_title.is-link:hover {
	color: #f0413e;
}
.order_info .goods_purchase_detail .purchase_product_card .card_sku {
	margin-top: 2px;
	color: #999;
	word-break: break-all;
}
.order_info .goods_purchase_detail .combo_item_card:last-of-type {
	margin-bottom: 4px;
}
.order_info .goods_purchase_detail .combo_item_card.is-fail {
	border-color: #ffccc7;
	background: #fff7f7;
}
.order_info .goods_purchase_detail .card_title_row {
	display: flex;
	align-items: flex-start;
	gap: 4px;
}
.order_info .goods_purchase_detail .line_status_tag {
	font-size: 12px;
	color: #666;
}
.order_info .goods_purchase_detail .line_status_tag.st-90,
.order_info .goods_purchase_detail .line_status_tag.st-100 {
	color: #f56c6c;
}
.order_info .goods_purchase_detail .line_status_tag.st-30,
.order_info .goods_purchase_detail .line_status_tag.st-40,
.order_info .goods_purchase_detail .line_status_tag.st-50 {
	color: #67c23a;
}
.order_info .goods_purchase_detail .card_fail_msg {
	margin-top: 2px;
	color: #f56c6c;
	word-break: break-all;
}
.order_info .goods_purchase_detail .purchase_footer {
	margin-top: 6px;
	padding-top: 6px;
	border-top: 1px dashed #eee;
}
.order_info .goods_purchase_detail .purchase_footer .return_address_row {
	font-size: 12px;
	color: #999;
}
.order_info .goods_purchase_detail .purchase_footer .return_address_head {
	display: flex;
	align-items: center;
	gap: 6px;
}
.order_info .goods_purchase_detail .purchase_footer .return_label {
	color: #666;
}
.order_info .goods_purchase_detail .purchase_footer .return_status_tag {
	color: #e6a23c;
}
.order_info .goods_purchase_detail .purchase_empty {
	font-size: 12px;
	color: #999;
	text-align: center;
	padding: 8px 0;
}

.order_list { list-style: none; margin: 0; padding: 0; }
.order_list > li {
	border: 1px solid #eee;
	margin-top: 12px;
	background: #fff;
}
.order_list .empty {
	border: none;
	text-align: center;
	padding: 40px;
	color: #999;
}
.info_top {
	background: #fafafa;
	padding: 8px 12px;
	font-size: 12px;
	color: #666;
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	align-items: center;
}
.info_top .row_check {
	margin-right: 0;
}
.info_top .shop_name { font-weight: 600; color: #333; }
.info_top .copy { color: #f0413e; margin-left: 6px; }
.info_top .static_tag { color: #ccc; cursor: not-allowed; margin-left: auto; }
.info_top .abnormal_btn { margin-left: 8px; }
.info_top .abnormal_btn:first-of-type { margin-left: auto; }
.order_info {
	display: flex;
	padding: 12px 8px;
	font-size: 12px;
	color: #333;
}
.order_info .col { padding: 0 6px; box-sizing: border-box; }
.goods_row { display: flex; margin-bottom: 10px; }
.thumb { width: 52px; height: 52px; object-fit: cover; border-radius: 2px; background: #f2f2f2; margin-right: 8px; flex-shrink: 0; }
.goods_meta { flex: 1; min-width: 0; }
.goods_meta .title { line-height: 1.4; max-height: 2.8em; overflow: hidden; font-weight: 500; margin-bottom: 4px; }
.goods_meta .meta_line { color: #666; margin-top: 2px; line-height: 1.5; word-break: break-all; }
.copy_icon { margin-left: 4px; cursor: pointer; color: #999; }
.copy_icon:hover { color: #f0413e; }
.static_link { margin-left: 8px; color: #409EFF; cursor: pointer; }
.relative_status_line { margin-top: 2px; }
.rel_ok { color: #67C23A; margin-right: 8px; }
.rel_empty { color: #F56C6C; margin-right: 8px; }
.muted_action { color: #999 !important; }
.relative_query_list { margin: 8px 0 0; padding: 0; list-style: none; }
.relative_query_list li { padding: 8px 0; border-bottom: 1px dashed #eee; }
.price_block { margin-bottom: 8px; }
.expand { color: #f0413e; }
.muted, .text-gray { color: #999; }
.buyer { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; margin-top: 4px; }
.buyer .eye { cursor: pointer; color: #666; }
.buyer .eye:hover { color: #f0413e; }
.buyer_mask { color: #999; }
.decode_fail_tag {
	display: inline-block;
	padding: 0 6px;
	line-height: 18px;
	font-size: 12px;
	color: #f0413e;
	border: 1px solid #f0413e;
	border-radius: 2px;
	margin-left: 4px;
	background: #fff5f5;
}
.address_sync_fail_tag {
	display: inline-block;
	padding: 0 6px;
	line-height: 18px;
	font-size: 12px;
	color: #E6A23C;
	border: 1px solid #E6A23C;
	border-radius: 2px;
	margin-left: 6px;
	cursor: help;
	vertical-align: middle;
	background: #fdf6ec;
}
.details.disabled { color: #ccc; cursor: not-allowed; pointer-events: none; }
.details.danger { color: #f0413e; }
.order_remarks {
	display: flex;
	flex-wrap: wrap;
	gap: 8px 24px;
	padding: 8px 12px 12px;
	border-top: 1px dashed #eee;
	font-size: 12px;
	background: #fcfcfc;
}
.order_remarks .remarks_item {
	display: flex;
	align-items: flex-start;
	min-width: 200px;
	max-width: 100%;
}
.order_remarks .txt {
	flex-shrink: 0;
	color: #666;
	margin-right: 4px;
}
.order_remarks .remarks {
	color: #333;
	word-break: break-all;
}
.order_remarks .red {
	color: #f0413e !important;
}
.decode_box p { margin: 8px 0; font-size: 13px; line-height: 1.5; }
.decode_box .virtual { color: #f0413e; }

</style>
<style >
.el-badge__content.is-fixed{right: -10px !important;top: -6px;}
</style>
